export default C => C.displayName || C.name || 'Component';
